import { styled } from "@mui/material";
import Badge from "@mui/material/Badge";

const HotspotBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-dot": {
    backgroundColor: theme.palette.secondary1[60],
  },
}));

export default HotspotBadge;
